import React from 'react';
import { Wrench, Settings, Gauge, Filter, Snowflake, Disc, Paintbrush, Sparkles } from 'lucide-react';
import siteConfig from '../config';

const iconMap = {
  wrench: Wrench,
  settings: Settings,
  gauge: Gauge,
  filter: Filter,
  snowflake: Snowflake,
  disc: Disc,
  paintbrush: Paintbrush,
  sparkles: Sparkles
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-black relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-20 left-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-0 w-96 h-96 bg-yellow-600/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Luxury Car Services We Offer
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-yellow-400 to-yellow-600 mx-auto mb-6"></div>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Comprehensive care for your luxury vehicle with dealership-level expertise
          </p>
        </div>

        {/* Services Grid - Mobile Optimized */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {siteConfig.services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Wrench;
            
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-gray-900 to-black border border-yellow-500/20 rounded-2xl p-6 hover:border-yellow-500/50 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl hover:shadow-yellow-500/20 cursor-pointer"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-8 h-8 text-black" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-yellow-400 transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
                  {service.description}
                </p>

                {/* Hover Accent Line */}
                <div className="h-1 w-0 bg-gradient-to-r from-yellow-400 to-yellow-600 mt-4 group-hover:w-full transition-all duration-500"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
